/**
 * 画面のURLの決まりごと。
 *
 *   /            … 物件の一覧
 *   /gk702       … その物件の内見
 *   /gk702?edit=1 … 視点作成モード（社内用）
 *
 * 以前は `/?property=gk702` だった。共有したときに読みにくく、
 * 物件が増えるほど分かりづらいので、物件IDをそのままパスにした。
 * 古いURLも受け付け、開いたときに新しい形へ書き換える。
 */

/** 物件IDとして許す形。パスに出るので、想定外の文字は弾く */
const ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

/** アプリの画面ではなく、配信中のファイルやAPIに使うパス */
const RESERVED = new Set(['api', 'assets', 'model', 'splat', 'properties', 'photos', 'floorplan', 'favicon.ico']);

/**
 * URLから物件IDを読む。一覧を出すときは null。
 * @param {{pathname: string, search: string}} location
 * @returns {{ id: string | null, legacy: boolean }}
 */
export function readPropertyLocation(location) {
  const fromPath = location.pathname.replace(/^\/+|\/+$/g, '');
  if (fromPath !== '' && !RESERVED.has(fromPath)) {
    if (!ID_PATTERN.test(fromPath)) throw new Error('物件IDの形式が正しくありません');
    return { id: fromPath, legacy: false };
  }

  const fromQuery = new URLSearchParams(location.search).get('property');
  if (fromQuery === null) return { id: null, legacy: false };
  if (!ID_PATTERN.test(fromQuery)) throw new Error('物件IDの形式が正しくありません');
  return { id: fromQuery, legacy: true };
}

/** 物件のURL（今のクエリのうち、edit だけ引き継ぐ） */
export function propertyPath(id, search = '') {
  const edit = new URLSearchParams(search).get('edit') === '1' ? '?edit=1' : '';
  return `/${encodeURIComponent(id)}${edit}`;
}

/** 一覧のURL */
export function indexPath(search = '') {
  const edit = new URLSearchParams(search).get('edit') === '1' ? '?edit=1' : '';
  return `/${edit}`;
}
